import { createAction } from '@reduxjs/toolkit';

export const setShowWelcome = createAction<boolean>('view/setShowWelcome');

export const setShowIsCalling = createAction<boolean>('view/setShowIsCalling');

export const setShowCallEnded = createAction<{ length?: number }>('view/setShowCallEnded');

export const setShowStartCall = createAction<boolean>('view/setShowStartCall');
